import React from 'react';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Typography } from '@wds/typography';
import { generateMetricsAttribute } from '@sm/metrics';
import useStyles from './useStyles';
import { HeroCardProps } from '~helpers/types';

const HeroCard = ({
  image,
  imageAlt,
  header,
  subHeader,
  ctaText,
  ctaUsage,
  ctaLink,
  amplitudeEvent,
  surveyId,
  collectorId,
  respondentId,
  templateType,
  utSource,
  utSource2,
  utSource3,
}: HeroCardProps): React.ReactElement => {
  const { card, subheader, imageContainer } = useStyles();

  return (
    <Box className={card} display="flex" alignItems="flex-start" flexDirection="column">
      <img className={imageContainer} src={image} alt={imageAlt} />
      <Box pt={7}>
        <Box pb={5} display="flex" flexDirection="column">
          <Box pb={4}>
            <Typography variant="cardTitle" weight="medium" component="h4">
              {header}
            </Typography>
          </Box>
          <Typography className={subheader} component="p" variant="body">
            {subHeader}
          </Typography>
        </Box>
        <Box display="flex">
          <Button
            size="md"
            color="alt"
            href={ctaLink}
            data-sm-metrics={generateMetricsAttribute({
              data: {
                amplitudeEvent,
                itemSelected: ctaUsage,
                templateType,
                surveyId,
                collectorId,
                respondentId,
                log: {
                  message: `${utSource}-${utSource2}-${utSource3}`,
                },
              },
            })}
          >
            {ctaText}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default HeroCard;
